import React, { Component } from 'react';
import { HashLink as HLink } from 'react-router-hash-link';
import homedata from '../../data/homedata.json';

class About extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL;
    let imgattr = 'image';

    return (
      <section id="about" className="p-80px-b">
         <div className="container">

            <div className="row">
               <div className="col-sm-8 offset-sm-2">
                  <div className="section-title text-center m-50px-b">
                     <h2>{homedata.about.sectiontitle}</h2>
                  </div>
               </div>
            </div>

            <div className="row align-items-center">

               <div className="col-md-6">
                  <div className="position-relative md-m-50px-b">
                     <div className="bordered-circle"></div>
                     <img
                       className="moveUpDown"
                       src={publicUrl + homedata.about.imgurl}
                       alt={imgattr}
                     />
                  </div>
               </div>

               <div className="col-md-6">
                  <h3 className="m-15px-b">
                    {homedata.about.title}
                  </h3>

                  <div
                    className="m-25px-b"
                    style={{ whiteSpace: "pre-line" }}
                  >
                    {homedata.about.content}
                  </div>

                  <div className="apps-buttons">

                     {/* ✅ FIXED BUTTON 1 */}
                     <HLink
                       smooth
                       to={homedata.about.btn1url}
                       className="btn btn-default btn-filled animated-btn"
                     >
                        <i className="icofont-calendar"></i>{" "}
                        <span
                          dangerouslySetInnerHTML={{
                            __html: homedata.about.btn1label
                          }}
                        ></span>
                     </HLink>

                     {/* ✅ FIXED BUTTON 2 */}
                     <HLink
                       smooth
                       to={homedata.about.btn2url}
                       className="btn btn-default btn-filled animated-btn"
                     >
                        <i className="icofont-medical-sign"></i>{" "}
                        <span
                          dangerouslySetInnerHTML={{
                            __html: homedata.about.btn2label
                          }}
                        ></span>
                     </HLink>

                  </div>
               </div>

            </div>
         </div>
      </section>
    );
  }
}

export default About;